// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mZ","cardInnerHeading":"m0","toggleWrapperClass":"m1","changeProfile":"m2 m1","textWrapperClass":"m3","toggleTextClass":"m4"};